import React, { useEffect, useState } from "react";
import "./GoldLoanScheme.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Edit, Trash } from "lucide-react";

const BASE_API_URL = "https://payyug.in";
const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

const getInitialFormState = () => ({
  type: "",
  rate24k: "",
  rate22k: "",
  city: "",
  date: new Date().toISOString().split("T")[0]
});

const GoldRate = () => {
 const [formData, setFormData] = useState(getInitialFormState());
  const [goldRates, setGoldRates] = useState([]);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  // const [selectedRow,setSelectedRow]=useState(null)

  const [editingId, setEditingId] = useState(null);

  /* ================= FETCH ================= */
  const fetchGoldRate = async () => {
    try {
      const res = await axios.get(
        `${BASE_API_URL}/api/gold-rate/list`,
        {
          params: {
            superAdminId: localStorage.getItem("adminuserId"),
            page: currentPage,
            limit: rowsPerPage,
          },
        },
      );

      setGoldRates(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchGoldRate();
  }, [currentPage, rowsPerPage]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "radio"
            ? value === "yes"
            : value,
    }));
  };

  /* ================= CREATE / UPDATE ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if(formData.serviceType || formData.schemeName){
    //   toast.warning("Please fill all required fields")
    // }

    const superAdminId = localStorage.getItem("adminuserId");
    const payload = {
      ...formData,
      superAdminId,
    };

    try {
      if (editingId) {
        console.log(editingId)
       const res= await axios.put(
          `${BASE_API_URL}/api/gold-rate/update/${editingId}`,
          payload,
        );
        toast.success(res.data.message||"Gold Rate Updated Successfully");
      } else {
       const res= await axios.post(
          `${BASE_API_URL}/api/gold-rate/create`,
          payload,
        );
        toast.success(res.data.message||"Gold Rate Created Successfully");
      }

      resetForm()
      fetchGoldRate();
    } catch (error) {
      toast.error(error.response.data.message);
      console.error("Submit error:", error);
    }
  };

  const resetForm = () => {
  setFormData(getInitialFormState());
  setEditingId(null);
};

  /* ================= EDIT ================= */
  const handleEdit = (scheme) => {
    setFormData(scheme);
    setEditingId(scheme.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    try {
      await axios.delete(`${BASE_API_URL}/api/gold-rate/delete/${id}`);
      toast.success("Gold Rate Deleted Successfully");
      fetchGoldRate();
    } catch (error) {
      toast.error(error.response.data.message)
      console.error("Delete error:", error);
    }
  };

  /* ================= PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="gold-loan-scheme-container">
      <h1 className="gold-loan-scheme-heading">Gold Rate</h1>

      {/* ================= TOP ================= */}
      <section className="gold-loan-scheme-top">
        <div className="gold-loan-scheme-top-header">
          <h2>
            {editingId
              ? "Update Gold Rate"
              : "Add Gold Rate"}
          </h2>
        </div>

        <form className="gold-loan-scheme-form" onSubmit={handleSubmit}>
          <div className="gold-loan-scheme-form-section">
            <div className="gold-loan-scheme-form-input-fields">
              <label>Gold Rate Type</label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
              >
                <option value="">Select Rate Type</option>
                <option value="Market">Market</option>
                <option value="Common">Common</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>24K Rate</label>
              <input
                type="text"
                name="rate24k"
                value={formData.rate24k}
                onChange={handleChange}
                required
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>22K Rate</label>
              <input
                type="text"
                name="rate22k"
                value={formData.rate22k}
                onChange={handleChange}
                required
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Date</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="gold-loan-scheme-form-submit-btn">
            <button type="submit" className="gl-submit-btn">
              {editingId ? "Update Rate" : "Add Rate"}
            </button>
            {editingId && <button className="gl-cancel-btn" onClick={resetForm}>Cancel</button>}
          </div>
        </form>
      </section>

      {/* ================= REPORT ================= */}
      <div className="gold-loan-scheme-report-container">
        <h1>Gold Rate Report</h1>

        <div className="gold-loan-scheme-report-filter-div">
          {/* <input
            type="text"
            placeholder="Search by Group / Type / Status..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          /> */}
          <div className="gold-loan-scheme-filter">
            <label>Show </label>
            <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="gold-loan-scheme-report-table-container">
          <table className="gold-loan-scheme-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Gold Rate Type</th>
                <th>24Karat Rate</th>
                <th>22Karat Rate</th>
                <th>Date</th>
                <th>City</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {goldRates.length > 0 ? (
                goldRates.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.type||"N/A"}</td>
                    <td>{item.rate24k||"N/A"}</td>
                    <td>{item.rate22k||"N/A"}</td>
                    <td>{new Date(item.date).toLocaleDateString("en-GB")||"N/A"}</td>
                    <td>{item.city||"N/A"}</td>
                    <td>
                      <div className="gold-loan-report-action-btns">
                        {/* <button className="gold-view-btn" onClick={() => setSelectedRow(item)}><Eye/></button> */}
                        <button className="gold-edit-btn" onClick={() => handleEdit(item)}><Edit/></button>
                        <button className="gold-delete-btn" onClick={() => handleDelete(item.id)}>
                          <Trash/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= PAGINATION ================= */}
      {totalPages > 1 && (
        <div className="gold-loan-scheme-pagination-div">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next ➡
          </button>
        </div>
      )}

    </div>
  );
};

export default GoldRate;
